document.querySelectorAll('[name=DateOfBirth]').forEach((dobElement) => {
  if (dobElement.nextElementSibling) {
    dobElement.nextElementSibling.setAttribute('name', 'DateOfBirthCopy');
  }
});
